import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	componentDeletedTitle: {
		id: 'project-components.flags.component-deleted-title',
		defaultMessage: '{name} deleted',
		description: "Flag's title - appears when component with given {name} was deleted.",
	},
});

const DeleteSuccess = (name: string): FlagConfiguration => ({
	type: 'success',
	isAutoDismiss: true,
	title: [messages.componentDeletedTitle, { name }],
	messageId: 'project-directories.components.flags.delete.flag.success',
	messageType: 'transactional',
});

export default DeleteSuccess;
